import en from './en.json';
import tr from './tr.json';
import es from './es.json';
import pt from './pt.json';
import de from './de.json';
import fr from './fr.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import zhCN from './zh-CN.json';

export const languages = ['en', 'tr', 'es', 'pt', 'de', 'fr', 'it', 'ja', 'ko', 'zh-CN'] as const;
export type Language = (typeof languages)[number];
export type CopyKey = keyof typeof en;
export const languageNames: Record<Language, string> = { en: 'English', tr: 'Türkçe', es: 'Español', pt: 'Português', de: 'Deutsch', fr: 'Français', it: 'Italiano', ja: '日本語', ko: '한국어', 'zh-CN': '简体中文' };
export const messages: Record<Language, typeof en> = { en, tr, es, pt, de, fr, it, ja, ko, 'zh-CN': zhCN };

export function detectLanguage(): Language {
  const saved = localStorage.getItem('sw:language');
  if (languages.includes(saved as Language)) return saved as Language;
  for (const raw of navigator.languages ?? [navigator.language]) {
    const normalized = raw.toLowerCase();
    if (normalized.startsWith('zh')) return 'zh-CN';
    const short = normalized.split('-')[0] as Language;
    if (languages.includes(short)) return short;
  }
  return 'en';
}
